// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-icon {
    position: relative;
    width: 0;
    height: 0;
    border-left: 10px solid transparent; /* Smaller arrow width */
    border-right: 10px solid transparent; /* Smaller arrow width */
    border-top: 20px solid #000; /* Smaller arrow height and color */
  }
`, "",{"version":3,"sources":["webpack://./src/containers/attachmentCards/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mCAAmC,EAAE,wBAAwB;IAC7D,oCAAoC,EAAE,wBAAwB;IAC9D,2BAA2B,EAAE,mCAAmC;EAClE","sourcesContent":[".download-icon {\n    position: relative;\n    width: 0;\n    height: 0;\n    border-left: 10px solid transparent; /* Smaller arrow width */\n    border-right: 10px solid transparent; /* Smaller arrow width */\n    border-top: 20px solid #000; /* Smaller arrow height and color */\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
